import React from 'react';

import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

import { useBiopharmaGroupState, useBiopharmaGroupActions } from './BiopharmaGroupContext';

import { addExternalJobBoard } from './restApi';

const NewExternalJobBoardForm = () => {
  const biopharmaGroupState = useBiopharmaGroupState();
  const { onResponse, onError, updateNewExternalJobBoardUrl, closeNewExternalJobBoardModal } = useBiopharmaGroupActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    addExternalJobBoard({
      onResponse,
      onError,
      body: {
        authenticityToken,
        newExternalJobBoard: biopharmaGroupState?.newExternalJobBoard,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="URL" id="external_job_board_url">
        <Input
          type="url"
          value={biopharmaGroupState?.newExternalJobBoard?.url || ''}
          onChange={(e) => {
            updateNewExternalJobBoardUrl(e.target.value);
          }}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              closeNewExternalJobBoardModal();
            }}
          >
            Cancel
          </Button>
          <Button type="submit">
            Add
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default NewExternalJobBoardForm;
